import styled from '@emotion/styled';

export const SocialWrapper = styled.div`
  display: flex;
  gap: 12px;
`;
